import { render, staticRenderFns } from "./websettings.vue?vue&type=template&id=2c4c5936"
import script from "./websettings.vue?vue&type=script&lang=js"
export * from "./websettings.vue?vue&type=script&lang=js"
import style0 from "./websettings.vue?vue&type=style&index=0&id=2c4c5936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports